import { createAsyncAction } from 'Libs/redux/utils';

import { searchContentsFn } from '../common/thunks';
import type { ContentSearchPayload, SearchContentsResponse } from '../common/types';

export const searchDrawerContents = createAsyncAction<SearchContentsResponse, ContentSearchPayload>(
  'drawer-contents/search',
  searchContentsFn,
);
